// Modules
import React, { useState, useContext } from "react";

// Context
import ApiContext from "../../contexts/ApiContext";

// Assets
import CloseIcon from "../../assets/img/svg/Close_icon.jsx";
import DvptFacile from "../../assets/img/png/strategies_icon/Dvpt_facile.png";
import DvptFaible from "../../assets/img/png/strategies_icon/Dvpt-faible.png";
import EquiFacile from "../../assets/img/png/strategies_icon/Equi-facile.png";
import EquiFaible from "../../assets/img/png/strategies_icon/Equi-faible.png";
import PlacFacile from "../../assets/img/png/strategies_icon/Plac-facile.png";
import PlacFaible from "../../assets/img/png/strategies_icon/Plac-faible.png";

const ModalResume = () => {
  const { isMobile, isTablet } = useContext(ApiContext);
  const [openModal, setOpenModal] = useState(false);

  return (
    <React.Fragment>
      <div className={"modal-container-resume"}>
        <div
          onClick={() => setOpenModal(false)}
          className={`modal-overlay ${openModal ? "" : "closed"}`}
        />
        <div className={`modal ${openModal ? "open" : "closed"}`}>
          <CloseIcon
            clssName="close-button"
            onClick={() => setOpenModal(false)}
          />

          {/* Essaie de mieux agencer les images avec le texte en mettant les images de stratégie sur la même ligne que les blocs de texte qui les décrivent */}
          <div className={`modal-content ${isMobile || isTablet ? "mobile" : ""}`}
          >
            <h4 className="strategie-title-main">
              Placement, équilibrée et développement : mieux comprendre les
              stratégies d’investissement Bevouac
            </h4>

            <p>
              La stratégie attribuée à un bien permet d’interpréter les
              caractéristiques essentielles de la zone dans laquelle il se
              trouve ainsi que la typologie du bien sélectionné.
            </p>
            <p className="margin-top-1">
              En interne, notre pôle data analyse des centaines de données afin
              d’évaluer si un bien :
            </p>

            <ul>
              <li>Se loue facilement</li>
              <li>Se revend facilement</li>
              <li>Est susceptible de prendre de la valeur</li>
            </ul>

            <p className="margin-top-1">
              Chaque critère se voit attribuer un coefficient multiplicateur en
              fonction de son importance.
              <br />
              En effet, chaque critère ne se vaut pas. Par exemple, le critère
              du prix au m² étant plus représentatif que le taux de chômage, son
              coefficient dans l'opération sera donc logiquement plus élevé que
              celui du taux chômage.
              <br />
              L’ensemble de ces valeurs est alors additionné afin de constituer
              un score qui va permettre d’assigner la stratégie correspondant au
              bien proposé.
            </p>
            <p className="margin-top-1">
              Pour cela, les critères analysés sont nombreux, par exemple :
            </p>

            <ul>
              <li>
                Pour évaluer la location, on croise l’évolution démographique,
                la part de locataires, la part d’étudiants et de jeunes actifs
              </li>
              <li>
                Pour anticiper la liquidité du bien, on prend en compte le prix
                moyen, la proximité avec le centre ville, la densité de
                commerces, l’esthétisme du bâti, les charges de copropriété
              </li>
              <li>
                Pour prévenir de la prise de valeur, on étudie l’évolution des
                prix, l’évolution démographique, le taux de chômage, le rapport
                entre le nombre d’acheteurs et de vendeurs
              </li>
            </ul>

            <p>
              Le but est donc de proposer une analyse du risque pris sur
              l’investissement grâce à des critères scientifiques et rationnels.
            </p>

            <h4 className="strategie-title-how">
              Comment interpréter chaque stratégie ?
            </h4>

            <h6 className="strategie-explain">La stratégie Placement</h6>
            <div className="explain-container">
              <p>
                C’est l’investissement le plus sécurisé, le plus prisé, avec un
                prix au m2 plus élevé. Parmi tous les biens sélectionnés, situés
                en plein cœur de ville, ce sont ceux qui se louent et se revendent
                le plus facilement et qui présentent le plus gros potentiel de
                prise de valeur. Ce type d’investissement est bien souvent très
                prisé dû à son emplacement dans les meilleurs quartiers et à son
                esthétisme supérieur à la moyenne.
              </p>

            <div className="strategie-images">
              <p className="strategie-type">
                Se loue facilement
              </p>
              <img src={PlacFacile} className="images-strategies" alt="strategie-explain" />
              <p className="strategie-type">
                Se revend facilement
              </p>
              <img src={PlacFacile} className="images-strategies" alt="strategie-explain" />
              <p className="strategie-type">
                Susceptible de prendre de la valeur
              </p>
              <img src={PlacFaible} className="images-strategies" alt="strategie-explain" />
            </div>
          </div>

            <h6 className="strategie-explain">La stratégie Équilibrée</h6>
            <div className={`explain-container ${isMobile || isTablet ? "mobile" : ""}`}>
              <p>
                Elle correspond à un investissement plus mesuré. Ce sont des biens
                plus éloignés du centre-ville dans des quartiers en transformation
                et résidentiels. Les prix y sont moins élevés qu’en hyper centre
                et permettent de saisir des opportunités avec un bon rendement et
                une bonne plus-value en limitant les risques.
              </p>

            <div className="strategie-images">
              <p className="strategie-type">
                Se loue facilement
              </p>
              <img src={EquiFacile} className="images-strategies" alt="strategie-explain" />
              <p className="strategie-type">
                Se revend facilement
              </p>
              <img src={EquiFacile} className="images-strategies" alt="strategie-explain" />
              <p className="strategie-type">
                Susceptible de prendre de la valeur
              </p>
              <img src={EquiFaible} className="images-strategies" alt="strategie-explain" />
            </div>
        </div>

            <h6 className="strategie-explain">La stratégie Développement</h6>
            <div className={`explain-container ${isMobile || isTablet ? "mobile" : ""}`}>
              <p>
                L’investissement est situé dans une zone périphérique de la ville.
                Les prix de l’immobilier sont plus accessibles, les rendements
                offerts sont donc plus attractifs mais nécessitent une prise de
                risque plus élevée. Les biens sont moins esthétiques et la
                location plus contraignante avec parfois plus de difficultés à
                trouver des locataires.
              </p>

            <div className="strategie-images">
              <p className="strategie-type">
                Se loue facilement
              </p>
              <img src={DvptFacile} className="images-strategies" alt="strategie-explain" />
              <p className="strategie-type">
                Se revend facilement
              </p>
              <img src={DvptFacile} className="images-strategies" alt="strategie-explain" />
              <p className="strategie-type">
                Susceptible de prendre de la valeur
              </p>
              <img src={DvptFaible} className="images-strategies" alt="strategie-explain" />
            </div>
        </div>

          </div>
        </div>
      </div>

      <button
        onClick={() => setOpenModal(true)}
        className={`open-button ${isMobile || isTablet ? "mobile" : ""}`}
      >
        En savoir plus sur les stratégies
      </button>
    </React.Fragment>
  );
};

export default ModalResume;
